const initialState = {
  menusaccess: [], 
};

const MenuAccess = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MENUACCESS":
      return {
        ...state,
        menusaccess: action.payload, 
      };

    case "REMOVE_MENUACCESS":
      return { ...initialState };

    default:
      return state;
  }
};

export default MenuAccess;
